import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Col,
  Row,
} from 'reactstrap';

import { ReactComponent as CloseButtonSvg } from 'assets/images/location/close-button-svg.svg';

import AppAsyncSelectValidation from 'components/App/AppAsyncSelectValidation';
import AppButton from 'components/App/Button';
import AppInputValidation from 'components/App/InputValidation';

import INITIAL_VALUE from 'constants/initialValue';

import styles from './ModalAddBankInfo.module.scss';

function ModalAddBankInfo(props) {
  const {
    isEdit,
    isOpen,
    loadingSearchBanking,
    loadingUpdateBankingOfPlace,

    validation,
    bankingList,
    onSearchBank,
    onToggleModal,
    isIntranet,
  } = props;

  const onSelectBank = React.useCallback((e) => {
    validation.setFieldValue('bankId', e.value);
  }, [validation]);

  const formatBankList = React.useMemo(
    () =>
      bankingList.map((bank) => ({
        label: bank.vnName,
        value: bank.bankId,
      })),
    [bankingList],
  );

  const buttonText = React.useMemo(() => {
    if (!isIntranet) return 'Gửi yêu cầu chỉnh sửa';
    return isEdit ? 'Sửa' : 'Thêm';
  }, [isIntranet, isEdit]);

  return (
    <div className={styles.Component}>
      <Modal
        fade
        size="lg"
        isOpen={isOpen}
        toggle={onToggleModal}
        className={styles.Modal}
      >
        <ModalHeader
          toggle={onToggleModal}
          className={styles.ModalHeader}
          close={(
            <button
              className={styles.ButtonClose}
              onClick={onToggleModal}
              type="button"
            >
              <CloseButtonSvg />
            </button>
          )}
        />

        <ModalBody className={styles.ModalBody}>
          <Label className="Label">Thêm tài khoản nhận thanh toán</Label>

          <hr className="Divider" />

          <Row className="Block">
            <Col md="4" className="Block__Title">
              Tên ngân hàng
              <code>*</code>
            </Col>

            <Col md="8" className="Block__Content__Wrapper">
              <AppAsyncSelectValidation
                name="bankId"
                placeholder="Vui lòng chọn ngân hàng"
                onChange={onSelectBank}
                defaultOptions={formatBankList}
                options={formatBankList}
                value={validation.values.bankId}
                validation={validation}
                isHiddenSearchable
                isLoading={loadingSearchBanking}
                onSearch={onSearchBank}
              />
            </Col>
          </Row>

          <Row className="Block">
            <Col md="4" className="Block__Title">
              Số tài khoản
              <code>*</code>
            </Col>

            <Col md="8" className="Block__Content__Wrapper">
              <AppInputValidation
                inputClassName={styles.Input}
                name="accountNumber"
                id="accountNumber"
                type="text"
                placeholder="Nhập số tài khoản"
                value={validation.values.accountNumber}
                validation={validation}
              />
            </Col>
          </Row>

          <Row className="Block">
            <Col md="4" className="Block__Title">
              Tên chủ tài khoản
              <code>*</code>
            </Col>

            <Col md="8" className="Block__Content__Wrapper">
              <AppInputValidation
                name="accountName"
                id="accountName"
                type="text"
                placeholder="Nhập tên chủ tài khoản"
                value={validation.values.accountName}
                validation={validation}
              />
            </Col>
          </Row>

          <div className="Button__Wrapper">
            <AppButton
              classes="Button Button__Cancel"
              onClick={onToggleModal}
              disabled={loadingUpdateBankingOfPlace}
            >
              Hủy
            </AppButton>

            <AppButton
              classes="Button Button__Save"
              onClick={validation.handleSubmit}
              loading={loadingUpdateBankingOfPlace}
            >
              {buttonText}
            </AppButton>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

ModalAddBankInfo.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  loadingSearchBanking: PropTypes.bool.isRequired,
  loadingUpdateBankingOfPlace: PropTypes.bool.isRequired,

  validation: PropTypes.instanceOf(Object),
  bankingList: PropTypes.instanceOf(Array),
  onSearchBank: PropTypes.func,
  onToggleModal: PropTypes.func.isRequired,
  isIntranet: PropTypes.bool,
};

ModalAddBankInfo.defaultProps = {
  validation: INITIAL_VALUE.OBJECT,
  bankingList: INITIAL_VALUE.ARRAY,
  onSearchBank: INITIAL_VALUE.FUNCTION,
  isIntranet: true,
};

export default React.memo(ModalAddBankInfo);
